import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b98d2584&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=b98d2584&lang=scss&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&id=b98d2584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98d2584",
  null
  
)

export default component.exports